import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import {
	LiveOrderApi,
	OrderPreparationStatusName,
} from "../../../../../../../../../../../../services/Api/Organization/types";
import PreparationStatusModalOptions from "./PreparationStatusModalOptions";

interface Props {
	status: OrderPreparationStatusName;
	order: LiveOrderApi;
	setOrder: (order: LiveOrderApi) => void;
	show: boolean;
	onHide: () => void;
	setLoading: (loading: boolean) => void;
	loading: boolean;
}

const PreparationStatusModal = ({ show, onHide, status, setLoading, setOrder, order, loading }: Props): JSX.Element => {
	const { t } = useTranslation();
	const { isSmallBreakpoint } = useWindowSize();

	return (
		<Modal show={show} onHide={onHide} className="preparation-status-modal" size={isSmallBreakpoint ? "sm" : "lg"}>
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.live_order.field.change_order_status.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<PreparationStatusModalOptions
					status={status}
					setLoading={setLoading}
					setOrder={setOrder}
					order={order}
					handleSuccessAction={onHide}
				/>
				{loading && <LoadingContainer />}
			</Modal.Body>
		</Modal>
	);
};

export default PreparationStatusModal;
